import { ArrowUpRight, BookOpenText } from 'lucide-react'
import CategoryIcon from './CategoryIcon.jsx'
import { getArticleUrl, hasDedicatedArticlePage } from '../lib/articleLinks.js'

function UnitCard({ unit, category, copy }) {
  const articleUrl = getArticleUrl(category.id)
  const dedicatedPage = hasDedicatedArticlePage(category.id)
  return (
    <article className="unit-card">
      <div className="unit-card-icon"><CategoryIcon categoryId={category.id} size={26} /></div>
      <div>
        <h3>{unit.name} <span>({unit.symbol})</span>{unit.ancient ? <small className="history-label">his</small> : null}</h3>
        <p>{unit.description}</p>
        <a href={articleUrl} target="_blank" rel="noreferrer">
          {dedicatedPage ? copy.readChapter : copy.readOverview} <ArrowUpRight aria-hidden="true" size={15} />
        </a>
      </div>
    </article>
  )
}

export default function UnitExplainers({ copy, category, fromUnit, toUnit }) {
  return (
    <section className="explainer-section" id={`about-${category.id}`} aria-labelledby="explainer-title">
      <div className="section-heading">
        <div>
          <div className="section-title-line">
            <BookOpenText className="section-heading-icon green" aria-hidden="true" size={29} strokeWidth={1.7} />
            <h2 id="explainer-title">{copy.knowTitle}</h2>
          </div>
          <p>{category.description}</p>
        </div>
        <a href={getArticleUrl(category.id)} target="_blank" rel="noreferrer">
          {hasDedicatedArticlePage(category.id) ? `${category.name} ${copy.articleChapter}` : copy.articleOverview} <ArrowUpRight aria-hidden="true" size={17} />
        </a>
      </div>
      <div className="unit-card-row">
        <UnitCard unit={fromUnit} category={category} copy={copy} />
        {toUnit.id !== fromUnit.id ? <UnitCard unit={toUnit} category={category} copy={copy} /> : null}
      </div>
    </section>
  )
}
